<div class="d-flex email-inner-container">
  @if (previewHtml$ | async; as previewHtml) {
  <iframe style="width: 100%" [srcdoc]="previewHtml"></iframe>
  }
</div>
